import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MailchimpService } from '../../../services/mailchimp.service';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent implements OnInit {
  email: string = '';
  firstName: string = '';
  lastName: string = '';
  isSubmitting: boolean = false;
  isSuccess: boolean = false;
  isError: boolean = false;
  message: string = '';

  constructor(private mailchimpService: MailchimpService) { }

  ngOnInit(): void {
    // Component initialization
  }

  onSubmit(form: NgForm): void {
    if (form.invalid) {
      return;
    }

    // Instead of using backend service, redirect to MailChimp directly
    // This is a workaround since we're removing backend dependencies
    
    // For now, we'll open the MailChimp subscription page in a new tab
    // In a real implementation, you might want to use the MailChimp embedded form
    window.open('https://insightfulitservices.us15.list-manage.com/subscribe?u=62b322b94327653e0495ebb3e&id=048fa3a588', '_blank');
    
    this.isSubmitting = false;
    this.isSuccess = true;
    this.message = 'Opening MailChimp subscription page... Please complete the subscription.';
    form.resetForm();
    
    // Reset form fields
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    
    // Reset success state after 5 seconds
    setTimeout(() => {
      this.isSuccess = false;
      this.message = '';
    }, 5000);
  }
}